import shawbrookLogo from "@/assets/img/shawbrook-bank-logo.png";
import ukCreditLogo from "@/assets/img/uk-credit-logo.svg";
import bambooLogo from "@/assets/img/bamboo-logo.svg";
import amigoLogo from "@/assets/img/amigo-logo.svg";
import lendableLogo from "@/assets/img/lendable-logo.svg";
import lendingWorksLogo from "@/assets/img/lending-works-stacked-logo.png";
import zutoLogo from "@/assets/img/zuto-logo.png";
import aaLogo from "@/assets/img/aa-logo.png";
import preciseMortgagesLogo from "@/assets/img/precise-mortgages-logo.png";
import paragonLogo from "@/assets/img/paragon-logo.png";
import centralTrustLogo from "@/assets/img/central-trust-logo.png";
import togetherLogo from "@/assets/img/together-logo.png";
import stepOneLogo from "@/assets/img/step-one-logo.svg";
import nortonFinanceLogo from "@/assets/img/norton-finance-logo.png";
import hsbcLogo from "@/assets/img/hsbc-logo.svg";
import halifaxLogo from "@/assets/img/halifax-logo.png";
import platformLogo from "@/assets/img/platform-logo.png";
import virginMoneyLogo from "@/assets/img/virgin-money-logo.svg";
import postOfficeLogo from "@/assets/img/post-office-logo.png";
import zopaLogo from "@/assets/img/zopa-logo.svg";

/* eslint-disable */
const lenders = {
    "unsecured": {
        25: { logo: shawbrookLogo, colour: "#cc0066"},
        37: { logo: ukCreditLogo, trustPilotId: "51f9040c00006400056d88a1" },
        13: { logo: bambooLogo, colour: "#d5efce", trustPilotId: "5714c3620000ff00058baca4" },
        16: { logo: bambooLogo, colour: "#d5efce", trustPilotId: "5714c3620000ff00058baca4" },
        23: { logo: amigoLogo, colour: "#006093", trustPilotId: "4ffc2326000064000517ecd1" },
        22: { logo: lendableLogo, colour: "#0f1430", trustPilotId: "58cf05070000ff00059ecd4c" },
        19: { logo: lendingWorksLogo, trustPilotId: "54e1ffe30000ff00057d7451" },
        20: { logo: zutoLogo, trustPilotId: "4c5153c900006400050d7636" },
        42: { logo: aaLogo },
        41: { logo: preciseMortgagesLogo },
        30: { logo: paragonLogo },
        40: { logo: centralTrustLogo },
        32: { logo: togetherLogo, colour: "#402B55" },
        33: { logo: stepOneLogo, colour: "#D11023" },
        38: { trustPilotId: "53e3bacf0000640005795d86" },
        24: { trustPilotId: "5177f376000064000527b34b" },
        46: {logo: postOfficeLogo },
        18: {logo: zopaLogo, colour: "#00C8B4" }
    },
    "secured": {
        4: { logo: paragonLogo },
        6: { logo: shawbrookLogo, colour: "#cc0066"},
        29: { logo: nortonFinanceLogo },
        28: { logo: togetherLogo, colour: "#402B55" },
        38: { logo: stepOneLogo, colour: "#D11023" }
    },
    "mortgage": {
        2: { logo: hsbcLogo },
        3: { logo: halifaxLogo, colour: "#3366c9" },
        4: { logo: platformLogo },
        5: { logo: virginMoneyLogo }
    }
};
/* eslint-enable */

function logoSrc(id, lenderType, securedShortCode) {
  if (!id) return "";
  let lenderList = lenders[lenderType];
  if (id in lenderList && lenderList[id].logo) {
    return lenderList[id].logo;
  }
  return securedShortCode
    ? `https://images.twenty7tec.com/images/small-logos/${securedShortCode}.gif`
    : `https://storage.googleapis.com/lender-management/${id}-logo`;
}

function brandColour(id, lenderType) {
  let lenderList = lenders[lenderType];
  if (id in lenderList) {
    return lenderList[id].colour;
  }
}

function trustPilotId(id, lenderType) {
  let lenderList = lenders[lenderType];
  if (id in lenderList) {
    return lenderList[id].trustPilotId;
  }
}

export function unsecuredLogoSrc(id) {
  return logoSrc(id, "unsecured");
}

export function securedLogoSrc(id, lenderCode) {
  return logoSrc(id, "secured", lenderCode);
}

export function mortgageLogoSrc(id) {
  return logoSrc(id, "mortgage");
}

export function mortgageLogoSrcShortcode(id, shortcode) {
  return logoSrc(id, "mortgage", shortcode);
}

export function unsecuredBrandColour(id) {
  return brandColour(id, "unsecured");
}

export function securedBrandColour(id) {
  return brandColour(id, "secured");
}

export function mortgageBrandColour(id) {
  return brandColour(id, "mortgage");
}

export function unsecuredTrustPilotId(id) {
  return trustPilotId(id, "unsecured");
}
